import { EventEmitter } from "@angular/core";

export class CartUpdateService {
  cartChange: EventEmitter<any> = new EventEmitter();
  constructor() {}
  emitCartChangeEvent() {
    this.cartChange.emit();
  }
  getCartChangeEmitter() {
    return this.cartChange;
  }
}


// WEBPACK FOOTER //
// ./src/app/Services/cartUpdate.service.ts